import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const emergentLoginUrl = () => {
  const redirect = window.location.origin + "/auth/callback";
  return `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
};

// Always start the OAuth flow from a fresh click so the provider issues a new state.
export const startLogin = (returnTo) => {
  try {
    if (returnTo) sessionStorage.setItem("kr_post_login", returnTo);
  } catch { /* storage unavailable (private mode) — login still works */ }
  window.location.assign(emergentLoginUrl());
};
